/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { StatisticsService } from './services/statistics.service';
import { SearchService } from './services/search.service';
import { TechStackService } from './services/tech-stack.service';
import { InsightsService } from './services/insights.service';
import { CohortService } from './services/cohort.service';
import { ProductService } from './services/product.service';
import { CategoryService } from './services/category.service';
import { TechStackTemplateService } from './services/tech-stack-template.service';
import { TaskService } from './services/task.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    StatisticsService,
    SearchService,
    TechStackService,
    InsightsService,
    CohortService,
    ProductService,
    CategoryService,
    TechStackTemplateService,
    TaskService,
    ApiConfiguration
  ],
})
export class BuyersCaddyApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BuyersCaddyApiModule> {
    return {
      ngModule: BuyersCaddyApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BuyersCaddyApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BuyersCaddyApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
